import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./pagestyles/SignUp.css";



const SignUp = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [error, setError] = useState("");

   const [showSignInModal, setShowSignInModal] = useState(false);

  const navigate = useNavigate();

 

  const handleSignUp = () => {
    // Validate form fields
    if (!email || !password || !confirmPassword) {
      setError("Please fill in all fields");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (!acceptTerms) {
      setError("Please accept the Terms of Service");
      return;
    }

    // Handle signup logic here
    console.log("Sign up with email:", email);
    setError("");
    // Implement account creation logic
    // navigate("/account"); // Example: redirect after successful signup
  };

  const handleSocialSignUp = (provider) => {
    // console.log(`Sign up with ${provider}`);
    // Implement OAuth signup logic here
  };

  return (
    <div className="signup-page">
      <div className="signup-container">
        <h3 className="signup-title">Create an account</h3>
        <p className="signup-subtext">
          Please enter your details to create an account.
        </p>

        {/* Error Message */}
        {error && <div className="error-message">{error}</div>}

        {/* Email Input */}
        <input
          type="email"
          placeholder="Enter your email"
          className="email-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        {/* Password Input */}
        <input
          type="password"
          placeholder="Create a password"
          className="password-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {/* Confirm Password Input */}
        <input
          type="password"
          placeholder="Confirm your password"
          className="confirm-password-input"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />

        {/* Terms Checkbox */}
        <div className="terms-checkbox">
          <input
            type="checkbox"
            id="terms"
            checked={acceptTerms}
            onChange={(e) => setAcceptTerms(e.target.checked)}
          />
          <label htmlFor="terms">
            I agree to the{" "}
            <Link to="/terms" className="terms-link">
              Terms of Service
            </Link>
          </label>
        </div>

        {/* Sign Up Button */}
        <button className="signup-btn" onClick={handleSignUp}>
          Create Account
        </button>

        {/* OR Divider */}
        <div className="or-divider">
          <span>OR</span>
        </div>

        {/* Social Buttons */}
        <div className="social-buttons">
          <button
            className="apple-btn"
            onClick={() => handleSocialSignUp("Apple")}
          >
            Sign up with Apple
          </button>
          <button
            className="google-btn"
            onClick={() => handleSocialSignUp("Google")}
          >
            Sign up with Google
          </button>
          <button
            className="facebook-btn"
            onClick={() => handleSocialSignUp("Facebook")}
          >
            Sign up with Facebook
          </button>
        </div>

        {/* Footer Links */}
        <div className="signup-footer">
          {/* <span>Already have an account?</span> */}
          
         {/* <span onClick={() => setShowSignInModal(true)}>
        Sign in
      </span> */}

           {/* <SignInModal 
              show={showSignInModal} 
             onClose={() => setShowSignInModal(false)} 
           /> */}

          {/* <Link to="/signin" className="signin-link">
            Sign in
          </Link> */}
        </div>
      </div>
    </div>
  );
};

export default SignUp;
